import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@utils';

export const useUserRiskAnalysisParameters = (userId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ['user-risk-analysis-parameters', userId],
    queryFn: async () => {
      const result = await apiClient.user.getRiskAnalysisParameters.query({ params: { userId } });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    enabled,
  });
};
